<template>
  <div class="change-healthy-card">
    <a-form-model :model="form" ref="ruleForm" :rules="rules">
      <div class="list-box">
        <a-form-model-item label="身份证号" prop="idCard">
          <a-input v-model="form.idCard" placeholder="请输入身份证号" />
        </a-form-model-item>
      </div>
      <div class="list-box">
        <a-form-model-item label="姓名" prop="name">
          <a-input v-model="form.name" placeholder="请输入姓名" />
        </a-form-model-item>
      </div>
      <div class="list-box">
        <a-form-model-item label="民族" prop="nation">
          <a-select
            v-model="form.nation"
            placeholder="请选择"
            style="width:120px"
          >
            <a-select-option
              v-for="it in nationsOption"
              :key="it.value"
              :value="it.value"
            >
              {{ it.text }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </div>
      <div class="list-box">
        <a-form-model-item label="家庭地址" prop="address">
          <a-input v-model="form.address" placeholder="请输入家庭地址" />
        </a-form-model-item>
      </div>
      <div class="list-box">
        <a-form-model-item label="本人手机号" prop="mobile">
          <a-input v-model="form.mobile" placeholder="请输入本人手机号" />
        </a-form-model-item>
      </div>
      <div class="list-box">
        <a-form-model-item label="联系人" prop="contacts">
          <a-input v-model="form.contacts" placeholder="请输入联系人姓名" />
        </a-form-model-item>
      </div>
      <div class="list-box">
        <a-form-model-item label="联系人手机号" prop="contactsPhone">
          <a-input
            v-model="form.contactsPhone"
            placeholder="请输入联系人手机号"
          />
        </a-form-model-item>
      </div>
      <div class="list-box">
        <a-form-model-item label="婚姻情况" prop="isMarried">
          <a-select
            v-model="form.isMarried"
            placeholder="请选择"
            style="width:120px"
          >
            <a-select-option
              v-for="item in MarriedOption"
              :key="item.id"
              :value="item.id"
            >
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </div>
    </a-form-model>
    <div class="bottom-btn hp_center" @click="saveChange">确认修改</div>
  </div>
</template>
<script>
import { getHealthyCard, changeHealthyCard } from '@/api/healthy-card'
export default {
  data() {
    let checkIdCard = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入身份证号码'))
      }
      let zz = /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0[1-9]|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/
      if (!zz.test(value)) {
        callback(new Error('身份证号码格式错误'))
      } else {
        callback()
      }
    }
    let checkMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号码'))
      }
      let zz = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
      if (!zz.test(value)) {
        callback(new Error('手机号码格式错误'))
      } else {
        callback()
      }
    }
    return {
      form: {
        address: '',
        contacts: '',
        contactsPhone: '',
        ehealthCardId: '',
        idCard: '',
        // isMarried: '',
        mobile: '',
        name: '',
        nation: '',
        phone: '',
      },
      nationsOption: [],
      MarriedOption: [
        // {
        //   id: '',
        //   text: '请选择',
        // },
        {
          id: 10,
          text: '未婚',
        },
        {
          id: 20,
          text: '已婚',
        },
        {
          id: 21,
          text: '初婚',
        },
        {
          id: 22,
          text: '再婚',
        },
        {
          id: 23,
          text: '复婚',
        },
        {
          id: 30,
          text: '丧偶',
        },
        {
          id: 40,
          text: '离婚',
        },
        {
          id: 90,
          text: '未说明类型',
        },
      ],
      rules: {
        idCard: [
          {
            validator: checkIdCard,
            trigger: 'blur',
          },
        ],
        mobile: [
          {
            validator: checkMobile,
            trigger: 'blur',
          },
        ],
        contactsPhone: [
          {
            validator: checkMobile,
            trigger: 'blur',
          },
        ],
      },
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      var res = JSON.parse(localStorage.getItem('nations'))
      this.nationsOption = res || []
      this.getData()
    },
    async getData() {
      let data = {
        idCard: this.$route.query.idCard,
      }
      let res = await getHealthyCard(data)
      this.form = res.data
    },
    async saveChange() {
      let data = {
        ...this.form,
      }
      data.recordId = data.id
      let res = await changeHealthyCard(data)
      this.$store
        .dispatch('setRelationRecords')
        .then(async () => {
          this.$router.push('/user-center/healthy-card')
        })
        .catch(() => {})
    },
  },
  mounted() {},
}
</script>
<style lang="less" scoped>
.change-healthy-card {
  .list-box {
    width: 840px;
    height: 80px;
    margin: 10px auto;
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(69, 157, 247, 0.19);
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding: 0 35px;

    /deep/ .ant-form-item {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0;
      label {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
      }
      .ant-input {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        text-align: right;
        border: none;
        outline: none;
      }
      .ant-input:focus {
        box-shadow: none;
      }
      .ant-input::-webkit-input-placeholder {
        /* placeholder颜色  */
        color: #999999;
      }
      .ant-select-selection {
        font-size: 22px;
        color: #333333;
        border: none;
      }
      .ant-select-focused .ant-select-selection,
      .ant-select-selection:focus,
      .ant-select-selection:active {
        box-shadow: none;
      }
      .ant-select-selection__placeholder,
      .ant-select-search__field__placeholder {
        height: 22px;
        font-size: 20px;
        color: #333333;
      }
      .has-error .ant-form-explain,
      .has-error .ant-form-split {
        text-align: right;
        padding-right: 15px;
      }
    }
    .ant-row::before,
    .ant-row::after {
      display: none;
    }
  }
  .bottom-btn {
    width: 606px;
    height: 83px;
    background: #3385ed;
    border-radius: 10px;
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #fffefe;
    margin: 120px auto;
  }
}
</style>
